<template>
  <div v-show="visible" class="fullscreen-loader">
    <div class="fullscreen-loader__wrapper">
      <logo-loader color="white" ref="loader"></logo-loader>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      timeoutRef: null,
      longerThanUsual: false
    }
  },
  props: {
    startingText: String
  },
  methods: {
    updateText(v) {
      this.$refs.loader.setText(v)
    },

    show(timeLimit = 10000) {
      const that = this
      this.timeoutRef = setTimeout(function () {
        that.$refs.loader.showLongerThanUsualInfo()

      }, timeLimit)
      this.visible = true
    },

    hide() {
      clearTimeout(this.timeoutRef)
      this.visible = false
      this.$refs.loader.hideLongerThanUsualInfo()
    }
  },

  mounted() {
    setTimeout(() => {
      this.$refs.loader.setText(this.startingText)
    }, 0)
  }
}
</script>

<style lang="scss" scoped>
.fullscreen-loader {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.83);

  &__wrapper {
    @include alignedFlex(center);
    width: 100%;
    height: 100%;
  }
}
</style>
